import React from 'react';
import PerguntaForm from './PerguntaForm';
import PerguntaService from 'services/perguntasService';

const EditarPergunta = ({ pergunta, closeModal, atualizarPerguntas }) => {
  const handleSubmit = async (data) => {
    await PerguntaService.atualizarPergunta(pergunta.id, data);
  };

  return (
    <PerguntaForm
      pergunta={pergunta}
      handleSubmit={handleSubmit}
      closeModal={closeModal}
      atualizarPerguntas={atualizarPerguntas}
    />
  );
};

export default EditarPergunta;
